import React, { useState, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import api from "../api/api";
import { FaFacebookF, FaYoutube, FaEnvelope } from "react-icons/fa";
import logo from "./logoo.png";
import "./Nav.css";

const navLinks = [
  { text: "Home", path: "/" },
  { text: "Good & Services", path: "/productFrontList" },
  { text: "Sign In", path: "/login" },
  { text: "Contact", path: "/contactpage" },
  { text: "Check Balance", path: "/royaltyATMScan" },
];

const Navbar = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [menuOpen, setMenuOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [suggestions, setSuggestions] = useState([]);

  const timeoutRef = useRef(null);

  // ================= BUILD SEARCH URL =================
  const buildSearchUrl = (value) => {
    return `/productFrontList?search=${encodeURIComponent(
      value.trim()
    )}`;
  };

  // ================= SEARCH PRODUCTS =================
  const handleSearchChange = async (value) => {
    setSearch(value);

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    if (!value.trim()) {
      setSuggestions([]);
      return;
    }

    timeoutRef.current = setTimeout(async () => {
      try {
        const res = await api.get(
          `/products-front-lists/?search=${value}`
        );

        const data = res.data?.results || res.data || [];

        setSuggestions(
          Array.isArray(data) ? data.slice(0, 8) : []
        );
      } catch (error) {
        console.log(error);
        setSuggestions([]);
      }
    }, 300);
  };

  // ================= CLICK PRODUCT =================
  const handleSelect = (item) => {
    setSearch("");
    setSuggestions([]);

    navigate(buildSearchUrl(item.name));
  };

  // ================= ENTER SEARCH =================
  const handleEnter = (e) => {
    if (e.key === "Enter") {
      if (!search.trim()) return;

      setSuggestions([]);

      navigate(buildSearchUrl(search));
    }
  };

  return (
    <nav className="navbar">

      {/* ================= TOP BAR ================= */}
      <div className="top-bar">
        <div className="top-left">
          <span>📍 Monrovia, Liberia</span>
        </div>

        <div className="top-right">
          <span className="follow">Follow us</span>

          <div className="socials">
            <a href="#">
              <FaFacebookF />
            </a>

            <a href="#">
              <FaYoutube />
            </a>

            <a href="mailto:info@zuluwhiskeyshipping.com">
              <FaEnvelope />
            </a>
          </div>
        </div>
      </div>

      {/* ================= MOBILE SEARCH (GOLD BAR) ================= */}
      <div className="mobile-search-bar">
        <div className="mobile-search-wrapper">
          <input
            type="text"
            placeholder="Search products..."
            value={search}
            onChange={(e) =>
              handleSearchChange(e.target.value)
            }
            onKeyDown={handleEnter}
          />

          {suggestions.length > 0 && (
            <div className="search-dropdown mobile-dropdown">
              {suggestions.map((item) => (
                <div
                  key={item.id}
                  className="dropdown-item"
                  onClick={() => handleSelect(item)}
                >
                  {item.name}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* ================= MAIN NAV ================= */}
      <div className="nav-container">

        {/* ================= LOGO ================= */}
        <div className="logo-section">
          <img src={logo} alt="Logo" />

          <div className="company-text">
            <h2>Zuluwhiskey Shipping</h2>
            <p>Fast • Secure • Reliable</p>
          </div>
        </div>

        {/* ================= DESKTOP SEARCH ================= */}
        <div className="nav-search">
          <input
            type="text"
            placeholder="Search products..."
            value={search}
            onChange={(e) =>
              handleSearchChange(e.target.value)
            }
            onKeyDown={handleEnter}
          />

          {suggestions.length > 0 && (
            <div className="search-dropdown">
              {suggestions.map((item) => (
                <div
                  key={item.id}
                  className="dropdown-item"
                  onClick={() => handleSelect(item)}
                >
                  {item.name}
                </div>
              ))}
            </div>
          )}
        </div>

        {/* ================= HAMBURGER ================= */}
        <div
          className={`hamburger ${menuOpen ? "active" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>

        {/* ================= NAV LINKS ================= */}
        <ul className={`nav-links ${menuOpen ? "open" : ""}`}>

          {navLinks.map((link) => (
            <li key={link.path}>
              <Link
                to={link.path}
                className={
                  location.pathname === link.path
                    ? "active"
                    : ""
                }
                onClick={() => setMenuOpen(false)}
              >
                {link.text}
              </Link>
            </li>
          ))}

        </ul>

      </div>
    </nav>
  );
};

export default Navbar;












// import React, { useState, useRef } from "react";
// import { Link, useLocation, useNavigate } from "react-router-dom";
// import api from "../api/api";
// import { FaFacebookF, FaYoutube, FaEnvelope } from "react-icons/fa";
// import logo from "./logoo.png";
// import "./Nav.css";

// const navLinks = [
//   { text: "Home", path: "/" },
//   { text: "Good & Services", path: "/productFrontList" },
//   { text: "Sign In", path: "/login" },
//   { text: "Contact", path: "/contactpage" },
// ];

// const Navbar = () => {
//   const location = useLocation();
//   const navigate = useNavigate();

//   const [menuOpen, setMenuOpen] = useState(false);
//   const [search, setSearch] = useState("");
//   const [suggestions, setSuggestions] = useState([]);

//   const timeoutRef = useRef(null);

//   // ================= BUILD SEARCH URL =================
//   const buildSearchUrl = (value) => {
//     return `/productFrontList?search=${encodeURIComponent(
//       value.trim()
//     )}`;
//   };

//   // ================= SEARCH PRODUCTS =================
//   const handleSearchChange = async (value) => {
//     setSearch(value);

//     if (timeoutRef.current) {
//       clearTimeout(timeoutRef.current);
//     }

//     if (!value.trim()) {
//       setSuggestions([]);
//       return;
//     }

//     timeoutRef.current = setTimeout(async () => {
//       try {
//         const res = await api.get(
//           `/products-front-lists/?search=${value}`
//         );

//         const data = res.data?.results || res.data || [];

//         setSuggestions(Array.isArray(data) ? data.slice(0, 8) : []);
//       } catch (error) {
//         console.log(error);
//         setSuggestions([]);
//       }
//     }, 300);
//   };

//   // ================= CLICK PRODUCT =================
//   const handleSelect = (item) => {
//     setSearch("");
//     setSuggestions([]);

//     navigate(buildSearchUrl(item.name));
//   };

//   // ================= ENTER SEARCH =================
//   const handleEnter = (e) => {
//     if (e.key === "Enter") {
//       if (!search.trim()) return;

//       setSuggestions([]);

//       navigate(buildSearchUrl(search));
//     }
//   };

// return (
//   <nav className="navbar">

//     {/* ================= TOP BAR ================= */}
//     <div className="top-bar">
//       <div className="top-left">
//         <span>📍 Monrovia, Liberia</span>
//       </div>

//       <div className="top-right">
//         <span className="follow">Follow us</span>

//         <div className="socials">
//           <a href="#"><FaFacebookF /></a>
//           <a href="#"><FaYoutube /></a>
//           <a href="mailto:info@zuluwhiskeyshipping.com">
//             <FaEnvelope />
//           </a>
//         </div>
//       </div>
//     </div>

//     {/* ================= MOBILE SEARCH (GOLD BAR) ================= */}
//     <div className="mobile-search-bar">
//       <div className="mobile-search-wrapper">
//         <input
//           type="text"
//           placeholder="Search products..."
//           value={search}
//           onChange={(e) => handleSearchChange(e.target.value)}
//           onKeyDown={handleEnter}
//         />

//         {suggestions.length > 0 && (
//           <div className="search-dropdown mobile-dropdown">
//             {suggestions.map((item) => (
//               <div
//                 key={item.id}
//                 className="dropdown-item"
//                 onClick={() => handleSelect(item)}
//               >
//                 {item.name}
//               </div>
//             ))}
//           </div>
//         )}
//       </div>
//     </div>

//     {/* ================= MAIN NAV ================= */}
//     <div className="nav-container">

//       <div className="logo-section">
//         <img src={logo} alt="Logo" />

//         <div className="company-text">
//           <h2>Zuluwhiskey Shipping</h2>
//           <p>Fast • Secure • Reliable</p>
//         </div>
//       </div>

//       {/* DESKTOP SEARCH ONLY */}
//       <div className="nav-search">
//         <input
//           type="text"
//           placeholder="Search products..."
//           value={search}
//           onChange={(e) => handleSearchChange(e.target.value)}
//           onKeyDown={handleEnter}
//         />

//         {suggestions.length > 0 && (
//           <div className="search-dropdown">
//             {suggestions.map((item) => (
//               <div
//                 key={item.id}
//                 className="dropdown-item"
//                 onClick={() => handleSelect(item)}
//               >
//                 {item.name}
//               </div>
//             ))}
//           </div>
//         )}
//       </div>

//       {/* HAMBURGER */}
//       <div
//         className={`hamburger ${menuOpen ? "active" : ""}`}
//         onClick={() => setMenuOpen(!menuOpen)}
//       >
//         <span></span>
//         <span></span>
//         <span></span>
//       </div>

//       {/* NAV LINKS */}
//       <ul className={`nav-links ${menuOpen ? "open" : ""}`}>
//         {navLinks.map((link) => (
//           <li key={link.path}>
//             <Link
//               to={link.path}
//               className={location.pathname === link.path ? "active" : ""}
//               onClick={() => setMenuOpen(false)}
//             >
//               {link.text}
//             </Link>
//           </li>
//         ))}
//       </ul>

//     </div>
//   </nav>
// );
// };

// export default Navbar;

